import ForgotPasswordScene from './ForgotPasswordScene'
export default ForgotPasswordScene